import Ellipse from './Ellipse'
import Line from './Line'
import Path from './Path'
import Polygon from './Polygon'
import Rectangle from './Rectangle'
import Text from './Text'

export default {
  [Ellipse.className]: Ellipse,
  [Line.className]: Line,
  [Path.className]: Path,
  [Polygon.className]: Polygon,
  [Rectangle.className]: Rectangle,
  [Text.className]: Text,
}
